module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-item cb-transition__tab",
    style: (_vm.themeColor)
  }, [_c('div', {
    staticClass: "cb-item__group"
  }, [_c('div', {
    staticClass: "cb-item__sub-group"
  }, [_c('div', {
    staticClass: "cb-item__price cb-item__sub-group--right"
  }, [_c('span', {
    staticClass: "cb-item__middle"
  }, [_vm._v("\n          " + _vm._s(_vm._f("cbCurrency")(_vm.amount, _vm.currencyCode)) + "\n        ")]), _vm._v(" "), (_vm.singleCart && _vm.chargedQuantity > 1) ? _c('span', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.sanitizeTags(_vm.priceInfo, [])),
      expression: "sanitizeTags(priceInfo, [])"
    }],
    staticClass: "cb-item__price--info"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cb-item__name  cb-item__sub-group--left"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + " "), (_vm.showQuantityReadOnly) ? _c('span', [_c('i', {
    staticClass: " cb-item__icon-remove"
  }, [_vm._v("×")]), _vm._v(" " + _vm._s(_vm.quantity))]) : _vm._e(), _vm._v(" "), (_vm.nonRecAddonTag) ? _c('span', {
    staticClass: "cb-label cb-label-recur",
    style: (_vm.backgroundColor)
  }, [_vm._v(_vm._s(_vm.ct('non_rec_addon.tag')))]) : _vm._e()]), _vm._v(" "), (_vm.singleCart && _vm.description) ? _c('div', {
    directives: [{
      name: "cb-html",
      rawName: "v-cb-html",
      value: (_vm.sanitizeTags(_vm.description, ['BR'])),
      expression: "sanitizeTags(description, ['BR'])"
    }],
    staticClass: "cb-item__desc"
  }) : _vm._e()]), _vm._v(" "), ((_vm.canShowQuantity || _vm.canShowRemove)) ? _c('div', {
    staticClass: "cb-item__sub-group"
  }, [(_vm.canShowQuantity) ? _c('quantity-template', {
    attrs: {
      "quantity": _vm.quantity,
      "meta": _vm.quantityMeta,
      "initial-quantity": _vm.getInitialQuantity
    },
    on: {
      "input": _vm.updateQuantity
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canShowRemove) ? _c('div', {
    staticClass: "cb-item__action cb-item__remove cb-item__sub-group--inline"
  }, [_c('span', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    on: {
      "click": function($event) {
        _vm.remove()
      }
    }
  }, [_vm._v(_vm._s(_vm.ct('cart.remove')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('item-description', {
    attrs: {
      "singleCart": _vm.singleCart,
      "item": _vm.item,
      "currencyCode": _vm.currencyCode
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-040869cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/LineItem.vue
// module id = 325
// module chunks = 24 34 35 36 37 66